import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIcnUpArrow = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={10} fill="currentColor" viewBox="0 0 24 24" {...props}><Path d="m0 16.67 2.829 2.83 9.175-9.339 9.167 9.339L24 16.67 12.004 4.5z" /></Svg>;
const Memo = memo(SvgIcnUpArrow);
export default Memo;